import { Location } from 'history';

export const getTrackingUrl = (
  { pathname, search, hash }: Location,
  withHash: boolean = false
) => {
  const { origin } = window.location;
  return `${origin}${pathname}${search}${withHash ? hash : ''}`;
};
